/**
 * A composable that detects clicks outside of a specified element
 * @param elementRef - A ref to the DOM element to watch
 * @param onOutsideClick - Function to call when a click outside is detected
 */
export const useClickOutside = (elementRef: Ref<HTMLElement | null>, onOutsideClick: () => void): void => {
    const handleClickOutside = (event: MouseEvent): void => {
        if (elementRef.value && !elementRef.value.contains(event.target as Node)) {
            onOutsideClick();
        }
    };

    onMounted(() => {
        document.addEventListener('mousedown', handleClickOutside);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('mousedown', handleClickOutside);
    });
};
